module.exports = __webpack_public_path__ + "img/icon_bank.c13f57e3.png";